import axios from "../axiosInstance";
import {
  GetMailchimpTemplateHtmlRequest,
  GetMailchimpTemplateHtmlResponse,
} from "./types";

export const getMailchimpTemplateHtml = async (
  payload: GetMailchimpTemplateHtmlRequest,
): Promise<GetMailchimpTemplateHtmlResponse> => {
  const response = await axios.post<GetMailchimpTemplateHtmlResponse>(
    "/api/private/mailchimp-templates/html",
    payload,
  );
  return response.data;
};
